import React from "react";
import PlaceholderImage from "../../assets/img/common/nft-project-img.png";
import { Link, useNavigate } from "react-router-dom";
import useNavigateToProfile from "../../hooks/useNavigateToProfile";
import UserPlaceHolderImg from "../../assets/img/common/user-placeholder-img.png";
import {
  useDislikeResultMutation,
  useLazyGetResultsQuery,
  useLikeResultMutation,
} from "../../redux/slices/api/resultApiSlice";
import { handleError } from "../../hooks/useApi";
import LikeButton from "../common/LikeButton";
import { FaCrown, FaRegComment } from "react-icons/fa";

const SpecialResultCard = ({
  resultData,
  projectData,
  containerClass = "w-full",
}) => {
  const {
    feature_image,
    _id: resultId,
    title,
    writers,
    likes,
    comments_count,
    premium,
  } = resultData ?? {};
  const { keywords } = projectData;
  const { navigateToProfile } = useNavigateToProfile();

  const [triggerGetResultsData] = useLazyGetResultsQuery();
  const onToggleLike = async () => {
    try {
      await triggerGetResultsData().unwrap();
    } catch (error) {
      handleError(error, null, true);
    }
  };

  const navigate = useNavigate();
  return (
    <button
      onClick={() => navigate(`/results/${resultId}`)}
      className={`${containerClass} flex h-40 rounded-xl shadow-xl border border-[#7D7D9C] bg-[#5d509224] hover:bg-[#7365ab47] pl-4 pr-2 py-1 justify-between items-center`}
    >
      {/* // -------- result detail -------- // */}
      <div className="max-w-[calc(100%-100px)] sm:max-w-[calc(100%-180px)] w-full flex flex-col pr-3 py-3 h-full justify-between">
        <section className="w-full flex flex-col">
          <div className="w-full flex flex-col mlg:flex-row mlg:justify-between">
            <p className="inline-flex items-center font-semibold text-base xl:text-xl text-left max-w-fit pr-2  text-white truncate">
              {premium && (
                <span>
                  <FaCrown className="text-yellow-500 text-lg xl:text-xl mr-1.5" />
                </span>
              )}{" "}
              <span className="truncate max-w-fit">{title}</span>
            </p>
          </div>

          <div className="flex items-center flex-wrap gap-2 mt-2 mb-1">
            {keywords?.length
              ? keywords?.slice(0, 3)?.map((item, index) => (
                  <Link
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    to={`/projects?keywords=${item}`}
                    key={index}
                    className="py-1 px-2 rounded-3xl bg-slate-200 text-slate-700 xl:text-xs text-[10px]"
                  >
                    {item}
                  </Link>
                ))
              : null}
          </div>
        </section>

        <div className="w-full flex justify-between items-center">
          <div className="flex items-center overflow-hidden ">
            <button
              onClick={(e) => {
                e.stopPropagation();
                navigateToProfile(writers[0]?._id, writers[0]?.role, false);
              }}
              className=" rounded-full overflow-hidden flex justify-center items-center cursor-pointer h-8 w-8 min-w-[2rem]"
            >
              <img
                src={writers[0]?.images?.profile || UserPlaceHolderImg}
                alt={title}
                className="transition-all duration-300 hover:scale-110 w-full h-full"
              />
            </button>
            <span className="flex flex-col ml-2 justify-between items-start max-w-full">
              <span
                onClick={(e) => {
                  e.stopPropagation();
                  navigateToProfile(writers[0]?._id, writers[0]?.role, false);
                }}
                className="text-sm font-bold text-white truncate max-w-[80%]"
              >
                {writers[0]?.fundername ??
                  `${writers[0]?.firstname} ${writers[0]?.lastname}`}
              </span>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  navigateToProfile(writers[0]?._id, writers[0]?.role, false);
                }}
                className=" text-custom-gray-200 text-xs "
              >
                {writers[0]?.title_rank ||
                  writers[0]?.location ||
                  writers[0]?.email}
              </button>
            </span>
          </div>
          <div className="hidden sm:flex items-start gap-x-4 -mb-2 ">
            <LikeButton
              likes={likes}
              useLikeMutation={useLikeResultMutation}
              useDislikeMutation={useDislikeResultMutation}
              id={resultId}
              onToggleLike={onToggleLike}
              containerClass="w-8 h-9"
              heartClass="w-14 h-14"
              countClass="text-xs -mt-4 text-custom-gray-100"
              likeType="result"
            />{" "}
            <div className="flex flex-col items-center">
              <FaRegComment size={18} className="text-custom-gray-800" />
              <span className="text-xs mt-1 text-custom-gray-100">
                {comments_count || 0}
              </span>
            </div>
          </div>
        </div>
      </div>
      {/* // -------- result  image -------- // */}
      <div className="h-[90%] flex flex-col justify-between">
        <div className="sm:min-w-[176px] min-w-[64px] max-sm:max-w-[75px] h-20 sm:h-[100%] rounded-lg sm:rounded-xl relative overflow-hidden">
          <img
            src={feature_image ?? PlaceholderImage}
            alt="feature_image"
            className="w-full h-full object-cover"
          />
        </div>{" "}
        <div className="flex sm:hidden items-start gap-x-6">
          <LikeButton
            likes={likes}
            useLikeMutation={useLikeResultMutation}
            useDislikeMutation={useDislikeResultMutation}
            id={resultId}
            onToggleLike={onToggleLike}
            containerClass="w-8 h-9"
            heartClass="w-14 h-14"
            countClass="text-xs -mt-4 text-custom-gray-100"
            likeType="result"
          />{" "}
          <div className="flex flex-col items-center">
            <FaRegComment size={18} className="text-custom-gray-800" />
            <span className="text-xs mt-1 text-custom-gray-100">
              {comments_count || 0}
            </span>
          </div>
        </div>
      </div>
    </button>
  );
};

export default SpecialResultCard;
